import { ref } from 'vue'
import {
  getPlaceholderBlockedDoctorName,
  isPlaceholderDoctorBlockedError
} from '@/utils/coverageErrors'

/**
 * Estado do aviso "Este médico não pode ser usado como coringa"
 * (`PlaceholderDoctorBlockedModal`). Fonte única para todos os modais que alocam
 * médico: em vez do toast genérico do `PLACEHOLDER_DOCTOR_BLOCKED`, o chamador passa o
 * erro para `handleError` e, se ele devolver `false`, segue com o tratamento atual.
 *
 * Cada chamada cria um estado próprio (sem singleton): cada modal chamador controla
 * o seu aviso.
 */
export function usePlaceholderDoctorBlocked() {
  const isOpen = ref(false)
  const doctorName = ref<string | null>(null)

  function open(name?: string | null): void {
    doctorName.value = name ?? null
    isOpen.value = true
  }

  function close(): void {
    isOpen.value = false
  }

  /**
   * `true` (e abre o aviso) quando o erro é `PLACEHOLDER_DOCTOR_BLOCKED`; senão `false`.
   * O `doctorName` do 422 (o coringa recusado) vence `name`: o chamador às vezes só
   * conhece o médico anterior do plantão.
   */
  function handleError(error: unknown, name?: string | null): boolean {
    if (!isPlaceholderDoctorBlockedError(error)) return false
    open(getPlaceholderBlockedDoctorName(error) ?? name)
    return true
  }

  return { isOpen, doctorName, open, close, handleError }
}
